var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.018,
    height: 130.207,
    viewBox: "0 0 131.018 130.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMS",
    transform: "translate(-106.566 -70.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stats--inject-184",
    transform: "translate(107.26 71.39)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_352",
    "data-name": "Ellipse 352",
    cx: 51.918,
    cy: 51.918,
    r: 51.918,
    transform: "translate(13.008 24.865)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.888
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stats--inject-184-2",
    "data-name": "freepik--stats--inject-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16091",
    "data-name": "Path 16091",
    d: "M180.2,240l-34.219,45.98a53.842,53.842,0,0,1-18.067-20.588Z",
    transform: "translate(-118.515 -163.286)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16092",
    "data-name": "Path 16092",
    d: "M180.257,240.74l-33.819,45.466a53.234,53.234,0,0,1-17.858-20.324Z",
    transform: "translate(-118.88 -163.689)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    y1: 3.922,
    x2: 3.153,
    transform: "translate(39.315 99.381)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16093",
    "data-name": "Path 16093",
    d: "M154.85,311.354a36.463,36.463,0,0,0,5.36,4.345l10.983-13.649",
    transform: "translate(-133.197 -197.104)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16094",
    "data-name": "Path 16094",
    d: "M143.22,310s1.365,1.67,3.362,3.754",
    transform: "translate(-126.859 -201.437)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16095",
    "data-name": "Path 16095",
    d: "M312.569,230.368a62.133,62.133,0,0,1-8.035,30.675L245.71,226.919,310.9,216c.532,2.248,1.188,6.938,1.188,6.938A59.247,59.247,0,0,1,312.569,230.368Z",
    transform: "translate(-182.718 -150.205)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16096",
    "data-name": "Path 16096",
    d: "M311.715,230.368a62.133,62.133,0,0,1-8.053,30.675L244.61,226.919,310.054,216c.532,2.248,1.192,6.938,1.192,6.938A59.993,59.993,0,0,1,311.715,230.368Z",
    transform: "translate(-182.118 -150.205)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16097",
    "data-name": "Path 16097",
    d: "M383.05,274.059a42.447,42.447,0,0,0,1.187-4.709",
    transform: "translate(-257.571 -179.282)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16098",
    "data-name": "Path 16098",
    d: "M351.1,288.04l10.069,4.882A72.9,72.9,0,0,0,365,284",
    transform: "translate(-240.157 -187.266)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x2: 5.346,
    y2: 2.593,
    transform: "translate(103.804 97.311)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16099",
    "data-name": "Path 16099",
    d: "M142.011,71.39c-15.565,3.886-34.751,20.788-34.751,20.788l.2.2L168.705,148.1Z",
    transform: "translate(-107.26 -71.39)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16100",
    "data-name": "Path 16100",
    d: "M143.211,73.6h-.041c-17.667,4.486-34.01,20.342-34.01,20.342l.2.2,59.925,54.529Z",
    transform: "translate(-108.296 -72.594)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x2: 5.96,
    y2: 5.628,
    transform: "translate(19.396 35.834)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16101",
    "data-name": "Path 16101",
    d: "M122.242,103.18a64.555,64.555,0,0,0-7.312,6.329l13.918,13.154",
    transform: "translate(-111.44 -88.716)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16102",
    "data-name": "Path 16102",
    d: "M138.026,95.1s-1.565.978-3.776,2.571",
    transform: "translate(-121.97 -84.312)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16103",
    "data-name": "Path 16103",
    d: "M165.775,116.038l1.31-.6-.278-1.574-1.451-.114a6.517,6.517,0,0,0-.728-1.365l.76-1.247-1.133-1.16-1.274.755a6.37,6.37,0,0,0-2.434-.992l-.359-1.451h-1.606l-.364,1.451a6.265,6.265,0,0,0-1.451.455l-1.147-.992-1.31.91.541,1.415a6.723,6.723,0,0,0-.91,1.2l-1.506-.155-.551,1.5,1.251.851a6.433,6.433,0,0,0-.091,1.065v.455l-1.315.728.414,1.547,1.488-.023a6.21,6.21,0,0,0,.819,1.3l-.655,1.356,1.238,1.033,1.187-.851a6.476,6.476,0,0,0,1.456.605l.237,1.433,1.6.141.482-1.365a6.371,6.371,0,0,0,1.538-.332l1.005,1.024,1.388-.8-.382-1.365a6.3,6.3,0,0,0,1.069-1.16l1.41.259.678-1.451-1.092-.91a6.7,6.7,0,0,0,.168-1.574Zm-2.375,0a3.995,3.995,0,1,1-1.168-2.828,4,4,0,0,1,1.168,2.828Z",
    transform: "translate(-131.497 -91.501)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16104",
    "data-name": "Path 16104",
    d: "M308.916,72.177l-7.971,2.043,2.016-7.971a8.19,8.19,0,1,0,5.956,5.915Z",
    transform: "translate(-186.085 -45.706)",
    fill: "#3fb9eb",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16105",
    "data-name": "Path 16105",
    d: "M321.454,69.513a8.389,8.389,0,0,0-5.61-5.683l-2.034,7.776Z",
    transform: "translate(-197.54 -44.521)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-184",
    transform: "translate(144.513 90.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-184-2",
    "data-name": "freepik--character--inject-184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16106",
    "data-name": "Path 16106",
    d: "M241.881,148.359l1.306,6.529s2.73,1.16,8.19,0l2.53-8.14s-2.5-.419-2.757-7.039l2.58-4.645s1.119,1.979,2.066-.086,1.979-5.419.259-5.5-3.1.255-6.019-1.365a25.94,25.94,0,0,1-5.937-5.332l-4.04,3.613s-1.206,10.064,3.785,13.931c-.71.137-.173,6.493.3,6.743C244.889,147.449,241.881,148.359,241.881,148.359Z",
    transform: "translate(-216.82 -118.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16107",
    "data-name": "Path 16107",
    d: "M241.111,129.09s-.159,6.229,1.024,10.351,4.827,6.474,6.779,5.669c1.365-.564,4.095-2.73,5.173-7.212",
    transform: "translate(-217.46 -121.559)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16108",
    "data-name": "Path 16108",
    d: "M252.106,139.694c.032.455.209.778.4.764s.318-.378.287-.814-.209-.778-.4-.764S252.078,139.257,252.106,139.694Z",
    transform: "translate(-223.454 -126.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16109",
    "data-name": "Path 16109",
    d: "M243.99,139.684c.027.455.2.778.4.764s.319-.378.291-.814-.209-.778-.4-.764S243.944,139.247,243.99,139.684Z",
    transform: "translate(-219.028 -126.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16110",
    "data-name": "Path 16110",
    d: "M245.987,139.67a4.582,4.582,0,0,1,.073,1.219,1.511,1.511,0,0,1-.56,1.056,1.928,1.928,0,0,0-.4.3.751.751,0,0,0,.068.883,6.669,6.669,0,0,0,.673.669",
    transform: "translate(-219.575 -127.325)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16111",
    "data-name": "Path 16111",
    d: "M251.235,151.42a4.868,4.868,0,0,1-1.065.869,2.448,2.448,0,0,1-1.82.1",
    transform: "translate(-221.409 -133.729)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16112",
    "data-name": "Path 16112",
    d: "M242.8,135.146a1.124,1.124,0,0,1,1.633-.874",
    transform: "translate(-218.385 -124.312)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16113",
    "data-name": "Path 16113",
    d: "M252.2,133.879a1.365,1.365,0,0,1,1.574-.569,2.184,2.184,0,0,1,1.251,1.242",
    transform: "translate(-223.508 -123.822)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16114",
    "data-name": "Path 16114",
    d: "M269.507,139.111s.532-1.765,1.724-1.561,1.433,1.11,1.188,2.543-.983,3.326-2.216,2.835a1.606,1.606,0,0,1-1.106-1.6",
    transform: "translate(-232.716 -126.161)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16115",
    "data-name": "Path 16115",
    d: "M264.26,160.53a21.788,21.788,0,0,0,.555,3.708,6.333,6.333,0,0,0,.61,1.82,2.53,2.53,0,0,0,1.442,1.233",
    transform: "translate(-230.081 -138.694)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16116",
    "data-name": "Path 16116",
    d: "M244.17,169.4l1.888-1.033a.719.719,0,0,0,.378-.573,21.232,21.232,0,0,0-.378-6.916",
    transform: "translate(-219.131 -138.885)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16117",
    "data-name": "Path 16117",
    d: "M236.386,116.47s-4.327-1.661-7.02,4.036-1.925,8.863-6.2,13.85a10.44,10.44,0,0,0-.792,13.135l2.193-.455s-.455-.974,1.447-1.288,4.632-.86,4.632-.86l.828.273,1.947-1.183a32.383,32.383,0,0,0-.2-7.58,10.688,10.688,0,0,1-2.589-4.654,73.522,73.522,0,0,1-.737-8.786s1.765-.223,3.185-2.935C234.593,118.8,235.958,118.518,236.386,116.47Z",
    transform: "translate(-206.188 -114.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16118",
    "data-name": "Path 16118",
    d: "M258.617,125.681c-4.618-1.1-9.04-3.685-10.747-7.307l3.476-2.593s7.28-3.594,10.16,4.445,1.005,22.585,1.005,22.585l-3.594-.651-.7.314a3.722,3.722,0,0,1-2.339-3.062,32.96,32.96,0,0,0-.673-3.949,10.538,10.538,0,0,0,2.612-5.278s2.193,2,2.953-1.511C261.265,126.363,260.418,124.439,258.617,125.681Z",
    transform: "translate(-221.148 -113.868)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16119",
    "data-name": "Path 16119",
    d: "M255.73,114.763a4.873,4.873,0,0,1,4.641-2.166",
    transform: "translate(-225.432 -112.537)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16120",
    "data-name": "Path 16120",
    d: "M233.315,149.53a10.814,10.814,0,0,1-.5,1.215c-.632,1.288-1.547,2.416-2.234,3.681a11.775,11.775,0,0,0-.8,9.259",
    transform: "translate(-210.965 -132.699)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.472
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16121",
    "data-name": "Path 16121",
    d: "M240.838,153.84a21.07,21.07,0,0,0-.778,11.233",
    transform: "translate(-216.659 -135.048)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.472
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16122",
    "data-name": "Path 16122",
    d: "M255.59,121s3.135,5.146,7.589,6.961",
    transform: "translate(-225.355 -117.149)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.472
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16123",
    "data-name": "Path 16123",
    d: "M257.52,119.358s5.769-.314,7.735,7.594",
    transform: "translate(-226.407 -116.253)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.472
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16130",
    "data-name": "Path 16130",
    d: "M217.326,277.394l-.068.291c-.455,1.861-2.653,12.284.824,21.816a95.406,95.406,0,0,0,3.935,9.053l6.884.794s-1.182-22.753-.933-28h1.611l5.263,28.106,8.352-1.309a24.121,24.121,0,0,1-.334-2.792c-.2-7.061,4.236-17.549,2.821-28.241l-4.941,4.049-3.244-6.7s-6.543,4.7-15.014-2.58Z",
    transform: "translate(-203.862 -199.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16131",
    "data-name": "Path 16131",
    d: "M207.259,188.478l2.3-8.713,4.468-.723s-.56-1.046.682-1.115,6.088-.978,6.088-.978l4.272,23.545,7.7-25.374a2.874,2.874,0,0,1,1.747-.223c1.292.1,4.372.56,4.55.855s.864.428.864.428,4.659-.155,5,2.061c.637,2.68-.91,21.593-.91,21.593s4.673,4.472,5.756,6.538l-3.367,4.855-6.192-3.285-4.19-2.7-.66,1.092,8.035,13.1-10.779,8.845-8.19-19.883-15.278,16.134-2.73-10.879,9.787-9.96-1.843-2.73s-3.562,6.511-5.4,6.647-5.569-4.823-5.915-5.46a.619.619,0,0,1,.328-.91s-2.953-4.209-2.034-5.269c.605-.642,4.336,1.547,5.956,1.169,1.142-.332,1.847-1.583,2.689-3.326a8.092,8.092,0,0,1-1.087-1.46Z",
    transform: "translate(-195.701 -146.514)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16132",
    "data-name": "Path 16132",
    d: "M208.027,219.221a20.79,20.79,0,0,0,2.107-2.9.958.958,0,0,1,1.365.642,8.459,8.459,0,0,0,1.065,2.9c.6.942-.3,2.093-1.238,3.162s-1.442,2.511-2.43,2.6-4.873-1.665-4.873-1.665a2.275,2.275,0,0,1-1.456-1.879c-.214-1.492-1.561-2.684-1.1-3.64s3.235,1.192,4.432,1.11A1.747,1.747,0,0,0,208.027,219.221Z",
    transform: "translate(-195.805 -169.048)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16133",
    "data-name": "Path 16133",
    d: "M254.67,200.5s12.494-13.358,12.949-14.582-1.333-2.657-1.333-2.657-1.542-1.069-1.083-2.411,3.057-3.244,3.276-4.259-.237-1.06-.237-1.06-5.687-1.274-6.069-1.028-3.3,11.17-3.3,11.17Z",
    transform: "translate(-224.854 -146.292)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16134",
    "data-name": "Path 16134",
    d: "M240.063,202.073s-3.64-21.8-4.027-22.649-3.144.241-3.144.241-3.735.1-3.9.937,2.534,4.823,2.534,4.823-2.457,4.095-2.73,4.846,9.85,13.158,9.85,13.158.76.846,1.365.846S240.063,202.073,240.063,202.073Z",
    transform: "translate(-210.748 -148.816)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16135",
    "data-name": "Path 16135",
    d: "M235.079,179.194l-5.587,1.065a.705.705,0,0,0-.532,1.037l2.275,3.849a.728.728,0,0,1,0,.733l-2.584,4.432a.728.728,0,0,0,.059.823l10.314,12.808a.61.61,0,0,0,.992-.055h0a.705.705,0,0,0,.1-.514l-4.181-23.591a.733.733,0,0,0-.86-.587Z",
    transform: "translate(-210.618 -148.859)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16136",
    "data-name": "Path 16136",
    d: "M254.08,201.248l7.407-25.979a.737.737,0,0,1,.814-.519l5.392.828a.723.723,0,0,1,.455,1.16L264.872,181a.723.723,0,0,0,0,.878l2.457,3.276a.733.733,0,0,1-.032.91Z",
    transform: "translate(-224.532 -146.44)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16137",
    "data-name": "Path 16137",
    d: "M255.25,193.3c-3.185,1.265-8.19,0-8.19,0l3.13,17.744Z",
    transform: "translate(-220.706 -156.554)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16138",
    "data-name": "Path 16138",
    d: "M202.737,218.359c-.551-.382-1.165-.382-1.424-.036a1.306,1.306,0,0,0-.046,1.242c.164.4.432.746.619,1.137.218.455.314,1,.519,1.474.742,1.715,2.7,2.493,4.459,3.1a2.234,2.234,0,0,0,3.148-.865l1.952-2.439a2.862,2.862,0,0,0,.573-.937c.359-1.2-.846-2.275-1.128-3.481a3.639,3.639,0,0,0-.328-1.256c-.241-.364-1.087-.455-1.26-.068",
    transform: "translate(-195.675 -168.915)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16139",
    "data-name": "Path 16139",
    d: "M252.425,233.16A4.973,4.973,0,0,0,251.06,237a14.3,14.3,0,0,0,.983,4.095q3.421,9.655,7.762,18.954l10.783-8.858-8.035-13.1.605-1.174",
    transform: "translate(-222.878 -178.279)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16140",
    "data-name": "Path 16140",
    d: "M220.731,231.81l1.874,2.907-9.846,9.941,2.716,10.879L230.859,239.5",
    transform: "translate(-202.012 -177.543)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_353",
    "data-name": "Ellipse 353",
    cx: 0.796,
    cy: 1.283,
    rx: 0.796,
    ry: 1.283,
    transform: "translate(30.007 56.851)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16141",
    "data-name": "Path 16141",
    d: "M228.76,260.1s8.017,5.915,16.288,3.139l-5.487-14.154Z",
    transform: "translate(-210.733 -186.955)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16142",
    "data-name": "Path 16142",
    d: "M214.69,193.644c0-2.248,2.234-8.945,2.234-8.945,1.124-.332,4.522-.769,4.522-.769",
    transform: "translate(-203.064 -151.447)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16143",
    "data-name": "Path 16143",
    d: "M285.43,177.81l3.59.4a2.179,2.179,0,0,1,2.025,2.234l-1.051,21.229a20.64,20.64,0,0,1,5.715,6.306",
    transform: "translate(-241.619 -148.112)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16144",
    "data-name": "Path 16144",
    d: "M290.937,230.53c-1.365.059-2.548.082-3.917.137",
    transform: "translate(-242.485 -176.845)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16145",
    "data-name": "Path 16145",
    d: "M291.3,230.39,288.12,232.5",
    transform: "translate(-243.085 -176.769)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16146",
    "data-name": "Path 16146",
    d: "M256.52,246.17l4.814,5.837",
    transform: "translate(-225.862 -185.369)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16147",
    "data-name": "Path 16147",
    d: "M259.65,246.19a8.406,8.406,0,0,1,1.77,1.274",
    transform: "translate(-227.568 -185.38)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16148",
    "data-name": "Path 16148",
    d: "M234.26,238.28a7.28,7.28,0,0,0,2.375.746",
    transform: "translate(-213.73 -181.069)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16149",
    "data-name": "Path 16149",
    d: "M205.607,224.356a.81.81,0,0,0-.278.933,2.379,2.379,0,0,0,.587.855l3.044,3.262a3.285,3.285,0,0,0,2.088,1.31,2.913,2.913,0,0,0,2.12-1.228,26.347,26.347,0,0,0,2.471-3.512,8.19,8.19,0,0,0,.792-1.488,8.434,8.434,0,0,0,.382-2.02q.259-2.539.523-5.078",
    transform: "translate(-197.935 -169.684)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16150",
    "data-name": "Path 16150",
    d: "M287.966,230.013s-8.331-4.017-10.51-6.024a73.531,73.531,0,0,1,.432-14.559",
    transform: "translate(-237.175 -165.345)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16151",
    "data-name": "Path 16151",
    d: "M273.54,214.61a6.411,6.411,0,0,0,1.146,3.444",
    transform: "translate(-235.139 -168.169)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16152",
    "data-name": "Path 16152",
    d: "M339.74,247.19l.2,1.392-1.165,1.843-.651-1.165Z",
    transform: "translate(-270.336 -185.925)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16153",
    "data-name": "Path 16153",
    d: "M297.12,262.84l10.31,8.353,4.654-7.453.914.7-5.332,8.608L298.025,265Z",
    transform: "translate(-247.99 -194.455)",
    fill: "#3fb9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16154",
    "data-name": "Path 16154",
    d: "M339.74,247.19l.2,1.392-1.165,1.843-.651-1.165Z",
    transform: "translate(-270.336 -185.925)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16155",
    "data-name": "Path 16155",
    d: "M297.12,262.84l10.31,8.353,4.654-7.453.914.7-5.332,8.608L298.025,265Z",
    transform: "translate(-247.99 -194.455)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16156",
    "data-name": "Path 16156",
    d: "M311.6,245.412l-4.654,7.453-10.71-8.849L306.4,229.21l10.524,7.821-1.624,2.543",
    transform: "translate(-247.51 -176.126)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16157",
    "data-name": "Path 16157",
    d: "M339.14,250.1l1.215-1.984L340.3,246.4",
    transform: "translate(-270.892 -185.495)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16158",
    "data-name": "Path 16158",
    d: "M312.424,263.938l-5.237,8.517-9.491-8.017-1.456-2.689",
    transform: "translate(-247.51 -193.861)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    x2: 8.481,
    y2: 6.206,
    transform: "translate(59.026 55.218)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x2: 8.481,
    y2: 6.206,
    transform: "translate(58.412 56.078)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    x2: 6.756,
    y2: 4.964,
    transform: "translate(57.615 57.065)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    x2: 9.141,
    y2: 6.675,
    transform: "translate(56.997 57.984)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    x2: 6.147,
    y2: 4.523,
    transform: "translate(56.2 59.154)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    x2: 6.379,
    y2: 4.736,
    transform: "translate(55.463 60.259)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    x2: 6.993,
    y2: 5.109,
    transform: "translate(54.849 61.365)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    x2: 8.476,
    y2: 6.206,
    transform: "translate(54.235 62.47)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    x2: 8.476,
    y2: 6.206,
    transform: "translate(53.621 63.576)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    x2: 8.476,
    y2: 6.206,
    transform: "translate(53.006 64.682)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16159",
    "data-name": "Path 16159",
    d: "M196.186,187.7s3.371,1.565,4.573,1.224,2.493-2.989,2.493-2.989l-6.406-12.5s1.915-3.767,1.679-5.114-2.407-3.449-2.407-3.449l-.409.4s-3.235-5.724-3.858-5.41,1.279,4.054,1.279,4.054a1.124,1.124,0,0,0-.91,1.06s-3.148,2.862-3.08,4.222,3.462,5.578,3.462,5.578Z",
    transform: "translate(-189.138 -138.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16160",
    "data-name": "Path 16160",
    d: "M191.317,175.136l1.156-1.442s2.111,1.82,2.5,1.442-2.116-4.513-2.593-4.513-3.076,3.362-2.98,4.418,3.362,5.382,3.362,5.382l3.558,12.971a11.465,11.465,0,0,0,4.131,1.151c1.538-.1,3.053-3.262,3.053-3.262l-6.515-12.189s2-4.017,1.679-5.114-2.193-2.73-2.32-3.74a2.047,2.047,0,0,0-.132,2.32",
    transform: "translate(-189.277 -143.986)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16161",
    "data-name": "Path 16161",
    d: "M194.81,170.4s.532-1.46,1.2-1.329,2.275,2.794,2.275,3.458a4,4,0,0,1-.332,1.4",
    transform: "translate(-192.229 -143.344)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16162",
    "data-name": "Path 16162",
    d: "M198.793,165.638s-3.016-6.251-3.949-5.787,1.456,3.949,1.988,5",
    transform: "translate(-192.131 -138.31)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16163",
    "data-name": "Path 16163",
    d: "M203.326,175.64a.946.946,0,0,0-.455.428,4.172,4.172,0,0,0-.528,2.871",
    transform: "translate(-196.3 -146.929)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    d: "M333.19,250.444s.714-1.511-.268-2.421-3.64-3.858-4.136-3.508,3.226,5.187,3.226,5.187",
    transform: "translate(-265.224 -184.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    d: "M329.365,253.009c-1.779-1.278-4.6-3-4.941-2.652-.491.491,3.435,3.572,3.435,3.572s-3.508-2.8-4-2.243c-.3.346,1.479,1.82,2.885,3.035",
    transform: "translate(-262.546 -187.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16166",
    "data-name": "Path 16166",
    d: "M326.5,257.3c-1.178-1.087-2.4-2.1-2.643-1.856-.487.491,3.221,5,4.095,5.164.974.168,1-1.069,1-1.069h0a1.6,1.6,0,0,0,1.1-1.338v-.159a1.365,1.365,0,0,0,.25-2.061l-.619-.419s-.614.582-.974.355",
    transform: "translate(-262.539 -190.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16167",
    "data-name": "Path 16167",
    d: "M333.19,250.444s.714-1.511-.268-2.421-3.64-3.858-4.136-3.508,3.226,5.187,3.226,5.187",
    transform: "translate(-265.224 -184.452)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16168",
    "data-name": "Path 16168",
    d: "M329.365,253.009c-1.779-1.278-4.6-3-4.941-2.652-.491.491,3.435,3.572,3.435,3.572s-3.508-2.8-4-2.243c-.3.346,1.479,1.82,2.885,3.035",
    transform: "translate(-262.546 -187.626)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16169",
    "data-name": "Path 16169",
    d: "M326.5,257.3c-1.178-1.087-2.4-2.1-2.643-1.856-.487.491,3.221,5,4.095,5.164.974.168,1-1.069,1-1.069h0a1.6,1.6,0,0,0,1.1-1.338v-.159a.941.941,0,0,0,.455-1.556",
    transform: "translate(-262.539 -190.406)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-184",
    transform: "translate(111.919 100.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--graphics--inject-184-2",
    "data-name": "freepik--graphics--inject-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16170",
    "data-name": "Path 16170",
    d: "M185.585,248.835V231.287a1.147,1.147,0,0,0-1.147-1.147H181.9",
    transform: "translate(-152.599 -187.017)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944,
    strokeDasharray: "1.888 1.888"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 29.242,
    height: 21.457,
    rx: 3,
    transform: "translate(0 32.854)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 7.698,
    height: 5.71,
    rx: 2.855,
    transform: "translate(2.857 35.279)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 23.436,
    height: 1.592,
    transform: "translate(2.789 44.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 13.577,
    height: 1.592,
    transform: "translate(12.644 39.383)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 13.577,
    height: 1.592,
    transform: "translate(12.644 35.138)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 23.368,
    height: 1.57,
    transform: "translate(2.921 49.051)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_354",
    "data-name": "Ellipse 354",
    cx: 1.183,
    cy: 1.183,
    r: 1.183,
    transform: "translate(31.758 60.895)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    x2: 0.428,
    transform: "translate(87.37 29.401)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16171",
    "data-name": "Path 16171",
    d: "M312.39,164.77h3.117a1.533,1.533,0,0,0,1.529-1.529V136.893a1.529,1.529,0,0,1,1.529-1.533h5.514",
    transform: "translate(-223.719 -135.36)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944,
    strokeDasharray: "1.921 1.921"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    x2: 0.428,
    transform: "translate(100.796 0)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.944
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 1.183,
    cy: 1.183,
    r: 1.183,
    transform: "translate(87.193 28.218)",
    fill: "#fff",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.944
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPms);
export default __webpack_public_path__ + "static/media/PMS.218aae732df9df01ddbb4145824080b5.svg";
export { ForwardRef as ReactComponent };